<template>
  <div>
    <div class="return-record-info">
      <crm-button
        v-if="
                  contractAuth.acceptanceDownload &&
                  contractAuth.acceptanceDownload.toggleStatus
                "
        :buttonType="'plain'"
        :size="'mini'"
        :text="'导出'"
        :disabled="isDownload"
        class="fr mb10"
        @click="handleExportBillsRecord"
      >
      </crm-button>
      <el-dropdown
        trigger="click"
        @command="handleAddAccept"
        class="fr mb10"
      >
        <crm-button :size="'mini'" :text="'新增验收记录'">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </crm-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="addNew">新增</el-dropdown-item>
          <el-dropdown-item command="addHad">已有验收记录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
      :data="dataList"
      v-loading="billsLoading"
      style="width: 100%; height: calc(100vh - 423px);"
    >
      <el-table-column prop="acceptanceTypeName" label="验收类型" align="center"></el-table-column>
      <el-table-column prop="acceptanceAmount" label="验收金额" align="center"></el-table-column>
      <el-table-column prop="acceptanceDate" label="验收时间" align="center"></el-table-column>
      <el-table-column prop="overdueDate" label="应收款逾期起算日期" align="center" width="160px"></el-table-column>
      <el-table-column prop="requestNo" label="流程编号" align="center"></el-table-column>
      <el-table-column prop="status" label="流程状态" align="center"></el-table-column>
      <el-table-column prop="applierName" label="业务申请人" align="center"></el-table-column>
      <el-table-column prop="teamName" label="申请部门" align="center"></el-table-column>
      <el-table-column prop="gmtCreated" label="申请时间" align="center"></el-table-column>
      <el-table-column prop="fileList" label="附件" align="center">
        <template slot-scope="scope">
          <p v-for="item in scope.row.fileList" :key="item.id">
            <a href="javascript:;" @click="getFildUrl(item)">
              {{ item.fileName }}
            </a>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="
                      contractAuth.acceptanceDelete &&
                      contractAuth.acceptanceDelete.toggleStatus
                    "
            @click="handleDeleteBillsRecord(scope)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="
                      contractAuth.acceptanceCount &&
                      contractAuth.acceptanceCount.toggleStatus
                    "
      style="height: 28px; line-height: 28px;">
      <span>合同已验收金额（元）：{{ totalAcceptanceAmount }}</span>
      <span style="margin-left: 20px;">未验收金额（元）：{{ unAcceptanceAmount }}</span>
    </div>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="dataPage.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="dataPage.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <choose-accept ref="chooseAccept" :contract-id="id" :info="info" @success="queryList"/>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapGetters } from 'vuex'
import { newDownloadByUrl } from '@/scripts/utils'
import ChooseAccept from './chooseAccept.vue';
import { Loading } from "element-ui";
import servicesInside from '~api/compact-inside';
import projectService from "@/services/api/project";

export default {
  components: {
    CrmButton,
    ChooseAccept,
  },
  props: {
    id: String,
    info: Object,
    detail: Object,
  },
  data() {
    return {
      isDownload: false,
      billsLoading: false,
      imagePreview: {
        showImage: false,
        url: "",
      },
      dataList: [], // 列表数据
      dataPage: {
        pageNumber: 1,
        pageSize: 5,
      },
      totalCount: 0,
      totalAcceptanceAmount: 0,
      unAcceptanceAmount: 0,
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      userInfo: "authority/userInfo",
    }),
  },
  methods: {
    handleSizeChange(value) {
      this.dataPage.pageNumber = 1
      this.dataPage.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.dataPage.pageNumber = value
      this.queryList()
    },
    // 导出开票记录
    handleExportBillsRecord() {
      const url = `/api/crmAcceptanceRecord/download/acceptance?contractId=${this.id}`;
      this.handleDownloadRecord(url);
    },
    async handleDownloadRecord(url) {
      try {
        this.isDownload = true;
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isDownload = false;
    },
    // 获取发票记录
    async queryList() {
      try {
        this.getCountNumber()
        this.billsLoading = true;
        const { pageNumber, pageSize } = this.dataPage;
        const { data } = await servicesInside.crmAcceptanceRecordList({
          contractId: this.id,
          pageNumber,
          pageSize,
        });
        this.billsLoading = false;
        this.dataList = data.results;
        this.dataPage.pageNumber = data.pageNumber;
        this.dataPage.pageSize = data.pageSize;
        this.totalCount = data.totalCount;
      } catch (e) {
        console.log(e)
        this.billsLoading = false;
      }
    },
    async getCountNumber() {
      try {
        const { data } = await servicesInside.crmAcceptanceRecordCount({
          contractId: this.id,
        });
        this.totalAcceptanceAmount = data.totalAcceptanceAmount
        this.unAcceptanceAmount = data.unAcceptanceAmount
      } catch (e) {
        console.log(e)
      }
    },
    // 删除发票记录
    async handleDeleteBillsRecord(scope) {
      try {
        await this.$confirm("当前操作，将把该验收记录从合同删除，是否确认？", "", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
        await servicesInside.deleteAcceptance({ id: scope.row.id });
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.dataPage.pageNumber = 1
        this.queryList();
      } catch (e) {
        console.log(e)
      }
    },
    // 新增开票
    handleAddAccept(type) {
      if (type === "addHad") {
        // eslint-disable-next-line no-unused-expressions
        this.$refs.chooseAccept && this.$refs.chooseAccept.open()
      } else {
        this.toAddAccept()
      }
    },
    // 新增开票
    async toAddAccept() {
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      const isTest = window.location.hostname.includes('crm.guahao-test.com')
      const tokenData = await projectService.getOaTokenInside();
      const oaEnv = isTest ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const oaUrl = isTest ? `#/main/workflow/req?iscreate=1&workflowid=121` : `#/main/workflow/req?iscreate=1&workflowid=182`
      const param = isTest
        ? `&field12415=${this.info.contractNo}&field12740=${this.info.loginId}&field12417=${this.detail.zxysdy}&field12741=${this.info.myContractConfirmationName}&field12401=${this.userInfo.teamId}&field12421=${this.info.customerId}&field12424=${this.info.businessId}&field12402=${this.info.contractAmountStr}&field12403=${this.totalAcceptanceAmount}`
        : `&field15709=${this.info.contractNo}&field17671=${this.info.loginId}&field16058=${this.detail.zxysdy}&field15215=${this.info.myContractConfirmationName}&field15207=${this.userInfo.teamId}&field16063=${this.info.customerId}&field16066=${this.info.businessId}&field15209=${this.info.contractAmountStr}&field15210=${this.totalAcceptanceAmount}`
      // eslint-disable-next-line no-useless-concat
      const OAUrl = `${oaEnv}?ssoToken=${tokenData.data.data}${oaUrl}${param}`
      window.open(OAUrl);
      setTimeout(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }, 2000);
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    // 关闭图片预览
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
  },
}
</script>
